import axios from "axios";
import config from "../../config/config";
import { buildAuthHeaders, buildAuthRequestConfig } from "../../utils/authSession";

function authHeaders() {
  return buildAuthHeaders();
}

export async function queryApplicantCoach({ question, quickAction, surfaceContext }) {
  const response = await axios.post(
    `${config.API_BASE_URL}/api/applicant/coach/query`,
    {
      question,
      quick_action: quickAction || "",
      surface_context: surfaceContext || {},
    },
    {
      ...buildAuthRequestConfig({ headers: authHeaders() }),
    }
  );

  return {
    reply: response.data?.reply || null,
    coachContext: response.data?.coach_context || null,
    replyLanguage: response.data?.reply_language || null,
  };
}

export async function loadApplicantCoachReplyLanguage() {
  const response = await axios.get(
    `${config.API_BASE_URL}/api/me`,
    {
      ...buildAuthRequestConfig({ headers: authHeaders() }),
    }
  );

  return {
    code: response.data?.preferred_communication_language_effective
      || response.data?.preferred_communication_language
      || "en",
    label: response.data?.preferred_communication_language_label || "English",
    direction: response.data?.preferred_communication_language_direction || "ltr",
    source: response.data?.preferred_communication_language_source || "fallback",
    source_detail: response.data?.preferred_communication_language_source_detail || "default.en",
  };
}
